export default __webpack_public_path__ + "static/media/six.8c9a0278.png";